// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__3Vrjx","map_title_style":"MapPOIS_map_title_style__uhjNe"};